import axios from 'axios';
import {useMutation} from 'react-query';

async function createComingSoonSubscription({email, styleId}) {
  const response = await axios.post(
    `/products/styles/${styleId}/coming_soon_subscriptions`,
    {
      email
    }
  );
  return response.data;
}

export default function useComingSoonSubscriptionMutation(options = {}) {
  return useMutation({
    mutationFn: createComingSoonSubscription,
    mutationKey: ['comingSoonSubscription'],
    onError: (error, variables, context) => {
      if (options.onError) {
        options.onError(error, variables, context);
      }
    },
    onSuccess: (data, variables) => {
      if (options.onSuccess) {
        options.onSuccess(data, variables);
      }
    },
    ...options
  });
}
